var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortAzIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.644 8.143h1.928v12.214a.643.643 0 0 0 .643.643H7.5a.643.643 0 0 0 .643-.643V8.143h1.928c.57 0 .86-.691.454-1.097L7.311 3.189a.643.643 0 0 0-.908 0L3.19 7.046c-.406.402-.117 1.097.454 1.097Zm16.069 5.143H14.57a.642.642 0 0 0-.643.643v1.285a.643.643 0 0 0 .643.643h2.25l-2.463 2.833a1.286 1.286 0 0 0-.43.96v.707a.643.643 0 0 0 .643.643h5.142a.642.642 0 0 0 .643-.643v-1.286a.643.643 0 0 0-.643-.642h-2.25l2.463-2.833a1.285 1.285 0 0 0 .43-.96v-.707a.643.643 0 0 0-.643-.643Zm1.25-3.432L18.58 3.426A.643.643 0 0 0 17.973 3H16.31a.643.643 0 0 0-.606.426L13.32 9.854a.643.643 0 0 0 .607.86h.996a.643.643 0 0 0 .61-.446l.178-.518h2.852l.177.518a.642.642 0 0 0 .618.446h.997a.643.643 0 0 0 .606-.86ZM16.482 7.5l.659-1.929L17.8 7.5h-1.318Z",
    fill: "#1C3F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAzIcon);
export default __webpack_public_path__ + "static/media/sort-az-icon.a1ae6436be12cb2757436fb8149c0cbb.svg";
export { ForwardRef as ReactComponent };